// Measures the real fixed header height and exposes it as --header-h so body padding
// always matches exactly, regardless of responsive height changes (mobile drawer trigger,
// wrapping nav links, etc.) — position:sticky was verified not to engage on this theme
// (computed style reports sticky/top:0 correctly, but the element still scrolls away with
// the page), so the header is pinned with position:fixed instead and this spacer keeps
// content from jumping underneath it.
(function () {
  function setHeaderHeight() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setHeaderHeight);
  } else {
    setHeaderHeight();
  }
  window.addEventListener('resize', setHeaderHeight);
  window.addEventListener('load', setHeaderHeight);
})();
